import {
  billboard,
  checklist,
  starRating,
  readMore,
  prosAndCons,
  accordion,
  author,
  profile,
  breadcrumb,
  categoryGuidesModule,
  copyModule,
  cta,
  linkWithLabel,
  embeddedAsset,
  featuredCards,
  figureModule,
  gridColumnModule,
  gridRowModule,
  headingModule,
  imageCalloutModule,
  readMoreModule,
  iframeModule,
  listItem,
  reviews,
  testimonialCard,
  video,
  list,
  imageModule,
  linkList,
  embeddedVideo,
  card,
  cookieToggle,
  authorGuidesModule,
  authorProfile,
  button,
  hero,
  heroCard,
  iconTile,
  widgetHtml,
  person,
  sponsoredByTag,
  countdown,
  navbar,
  supplierRow,
  richTextModule,
  experienceEntitySelector,
  quoteBlock,
  container,
  palette,
} from '@uswitch/ev-components/lib/components/defaults/components'

interface Component {
  variations: object
  wrapperConfig?: object
  hydrate?: boolean | object
  features?: object
}

interface ComponentMap {
  [key: string]: Component
}

export const Components: ComponentMap = {
  billboard,
  checklist,
  starRating,
  readMore,
  prosAndCons,
  accordion: { ...accordion, hydrate: false },
  author,
  profile,
  breadcrumb,
  categoryGuidesModule,
  copyModule,
  cta: {
    ...cta,
    hydrate: false,
  },
  linkWithLabel,
  embeddedAsset,
  featuredCards,
  figureModule,
  gridColumnModule,
  gridRowModule,
  headingModule,
  imageCalloutModule,
  readMoreModule,
  iframeModule,
  listItem,
  reviews: { ...reviews, hydrate: true },
  testimonialCard,
  video,
  list,
  imageModule: {
    ...imageModule,
    wrapperConfig: { spacingTop: 0, spacingBottom: [12, 24] },
  },
  linkList,
  embeddedVideo,
  card,
  cookieToggle,
  authorGuidesModule,
  authorProfile,
  button,
  hero,
  heroCard,
  iconTile,
  widgetHtml: { ...widgetHtml, hydrate: false, wrapperConfig: { spacingY: ['sm', 'md'] } },
  person,
  sponsoredByTag,
  countdown,
  navbar,
  supplierRow,
  richTextModule,
  experienceEntitySelector,
  quoteBlock: { ...quoteBlock, wrapperConfig: undefined },
  container,
  palette,
}

export default Components
